module.exports = __webpack_public_path__ + "img/diagram-3-fill.8cd96289.svg";